import React from 'react';
import { Link } from 'react-router-dom';
import useWorkClock, { formatElapsed } from '../../hook/useWorkClock';
import WorkClockControls from '../WorkClockControls/WorkClockControls';
import { TIME_LOG_STATE } from '../../constants/timeLog';
import { TIME_LOGS } from '../../utils/const';
import './HeaderWorkClock.scss';

function HeaderWorkClock() {
  const {
    clockState,
    clockStateLabel,
    elapsedSeconds,
    actionLoading,
    selectedDeviceId,
    selectedDeviceName,
    activeShift,
    handleClockIn,
    handlePause,
    handleResume,
    handleClockOut,
  } = useWorkClock({ loadLogs: false });

  const badgeClass = {
    [TIME_LOG_STATE.OFF]: 'off-shift',
    [TIME_LOG_STATE.ACTIVE]: 'on-shift',
    [TIME_LOG_STATE.PAUSED]: 'paused-shift',
  }[clockState] || 'off-shift';

  const isOffShift = clockState === TIME_LOG_STATE.OFF;
  const deviceLabel = activeShift?.deviceName || selectedDeviceName;
  const needsDeviceSelection = isOffShift && !selectedDeviceId;

  return (
    <div className="header-work-clock" aria-label="Work clock">
      <div className="header-work-clock-status">
        <span className="header-work-clock-label">Time</span>
        <span className="header-work-clock-timer">{formatElapsed(elapsedSeconds)}</span>
        <span className={`header-work-clock-badge ${badgeClass}`}>
          {clockStateLabel}
        </span>
        {deviceLabel ? (
          <span className="header-work-clock-device" title={`Device: ${deviceLabel}`}>
            {deviceLabel}
          </span>
        ) : null}
        {needsDeviceSelection ? (
          <Link
            to={TIME_LOGS.PAGE}
            className="header-work-clock-select-device"
            state={{ highlightDeviceSelect: true }}
          >
            Select device
          </Link>
        ) : null}
      </div>
      <div className="header-work-clock-actions">
        <WorkClockControls
          variant="header"
          clockState={clockState}
          actionLoading={actionLoading}
          onClockIn={handleClockIn}
          onPause={handlePause}
          onResume={handleResume}
          onClockOut={handleClockOut}
        />
        <Link to={TIME_LOGS.PAGE} className="header-work-clock-link">
          Logs
        </Link>
      </div>
    </div>
  );
}

export default HeaderWorkClock;
